import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from '../ui/CTAButton';
const fadeUp = {
  hidden: {
    opacity: 0,
    y: 24
  },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.55,
      delay: i * 0.12,
      ease: 'easeOut'
    }
  })
};
export function GuaranteeSection() {
  const ref = useRef(null);
  const inView = useInView(ref, {
    once: true,
    amount: 0.2
  });
  return <section id="booking-form" className="relative w-full bg-[#1A2B4A] dot-texture py-24 px-6 overflow-hidden" data-id="element-274">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[400px] bg-[#4ECDC4]/10 rounded-full blur-[120px] pointer-events-none" data-id="element-275" />

      <div ref={ref} className="max-w-3xl mx-auto relative z-10" data-id="element-276">
        <motion.div custom={0} variants={fadeUp} initial="hidden" animate={inView ? 'visible' : 'hidden'} className="text-center mb-10" data-id="element-277">
          <span className="inline-block bg-[#4ECDC4] text-[#1A2B4A] text-xs font-bold uppercase px-3 py-1 rounded-full mb-4 tracking-wider" data-id="element-278">
            Our Promise
          </span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-white mb-4 leading-tight" data-id="element-279">
            Zero Risk. Real Results.
          </h2>
        </motion.div>

        {/* Guarantee card */}
        <motion.div custom={1} variants={fadeUp} initial="hidden" animate={inView ? 'visible' : 'hidden'} className="relative rounded-2xl p-8 sm:p-12 text-center mb-10 overflow-hidden" style={{
        background: 'rgba(255,255,255,0.07)',
        backdropFilter: 'blur(12px)',
        border: '1px solid rgba(78, 205, 196, 0.5)',
        boxShadow: '0 0 60px rgba(78, 205, 196, 0.15), inset 0 0 60px rgba(78, 205, 196, 0.03)'
      }} data-id="element-280">
          {/* Glow ring */}
          <div className="absolute inset-0 rounded-2xl pointer-events-none" style={{
          boxShadow: '0 0 80px rgba(78,205,196,0.2)'
        }} data-id="element-281" />

          <div className="flex justify-center mb-6" data-id="element-282">
            <div className="w-20 h-20 rounded-full flex items-center justify-center" style={{
            background: 'rgba(78, 205, 196, 0.15)',
            border: '2px solid rgba(78, 205, 196, 0.6)',
            boxShadow: '0 0 30px rgba(78, 205, 196, 0.3)'
          }} data-id="element-283">
              <ShieldCheckIcon className="w-9 h-9 text-[#4ECDC4]" data-id="element-284" />
            </div>
          </div>

          <h3 className="text-2xl sm:text-3xl font-black text-white mb-4" data-id="element-285">
            Our Performance Guarantee
          </h3>

          <p className="text-lg sm:text-xl text-white/80 leading-relaxed mb-8 max-w-xl mx-auto" data-id="element-286">
            We guarantee{' '}
            <span className="text-[#4ECDC4] font-bold" data-id="element-287">
              cost per hire for launched reps
            </span>
          </p>

          <CTAButton size="large" data-id="element-288" />

          <p className="text-white/40 text-sm mt-6" data-id="element-289">
            Limited to 5 new partners per month.
          </p>
        </motion.div>

        <motion.p custom={2} variants={fadeUp} initial="hidden" animate={inView ? 'visible' : 'hidden'} className="text-center text-white/30 text-sm" data-id="element-290">
          For D2D companies doing $2M+/year with infrastructure to support 20+
          new hires monthly.
        </motion.p>
      </div>
    </section>;
}